export default function delay(timeout = 300) {
  return new Promise((resolve)=>{
    setTimeout(() => {
      resolve()
    }, timeout);
  })
}
